export default function Machines_B_0 (number = 1) {
  return {
    name: '传送带',
    icon: '/static/img/machines/b0.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_B/Machines_B_0.js